/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.module.css';

const Cell = ({ text, selected, correct, isSubmitted: isSubmittedProps, onClick: onClickProps }) => {
  const onClick = React.useCallback(() => {
    onClickProps?.(text);
  }, [text, onClickProps]);

  const isCorrectionVisible = isSubmittedProps && typeof correct === 'boolean';

  return (
    <div
      className={classNames({
        [styles.cell]: true,
        [styles.cellSelected]: selected,
        [styles[`cell${correct}`]]: isCorrectionVisible,
      })}
      style={{ fontSize: 20, fontWeight: 600 }}
      onClick={onClick}
    >
      {text}
    </div>
  );
};

Cell.defaultProps = {
  correct: false,
};

Cell.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  correct: PropTypes.bool,
  selected: PropTypes.bool.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
};

export default Cell;
